import { AlertTriangle, CheckCircle2, Clock3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { useBillingStatus, isBillingFrontendEnabled } from '../hooks/useBilling';

export const BillingStatusBanner = () => {
  const { t } = useTranslation('common');
  const { lng = 'es' } = useParams();
  const { data } = useBillingStatus();

  if (!isBillingFrontendEnabled()) {
    return null;
  }

  const subscription = data?.subscription;
  const status = subscription?.status;

  if (!data?.billing_enabled) {
    return (
      <div className="rounded-lg border border-line bg-white px-4 py-3 text-sm text-muted">
        {t('billing.banner.disabled')}
      </div>
    );
  }

  if (status === 'active' || status === 'trialing') {
    return (
      <div className="flex items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900">
        <CheckCircle2 className="h-4 w-4" aria-hidden="true" />
        <span>
          {t(status === 'trialing' ? 'billing.banner.trialing' : 'billing.banner.active')}
        </span>
      </div>
    );
  }

  if (status === 'past_due') {
    return (
      <Link
        to={`/${lng}/billing`}
        className="flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900"
      >
        <Clock3 className="h-4 w-4" aria-hidden="true" />
        <span>{t('billing.banner.pastDue')}</span>
      </Link>
    );
  }

  return (
    <Link
      to={`/${lng}/billing`}
      className="flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-900"
    >
      <AlertTriangle className="h-4 w-4" aria-hidden="true" />
      <span>{t('billing.banner.actionRequired')}</span>
    </Link>
  );
};
